// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Oscillator$WebAudio from "../Oscillator/Oscillator.bs.js";

function make(audioCtx) {
  var paramOscillator = audioCtx.createGain();
  paramOscillator.gain.value = 0.5;
  var oscillatorNode = Oscillator$WebAudio.make(/* Sine */0, audioCtx);
  oscillatorNode.oscillatorNode.frequency.value = 3.0;
  var constantSourceNode = audioCtx.createConstantSource();
  Oscillator$WebAudio.connect(paramOscillator, oscillatorNode);
  constantSourceNode.connect(paramOscillator);
  var outputGain = audioCtx.createGain();
  paramOscillator.connect(outputGain.gain);
  return {
          audioContext: audioCtx,
          oscillatorNode: oscillatorNode,
          outputGain: outputGain
        };
}

function connect(target, lfo) {
  lfo.outputGain.connect(target);
  return lfo;
}

function start(lfo) {
  Oscillator$WebAudio.start(lfo.oscillatorNode);
  return lfo;
}

function setFrequency(frequency, lfo) {
  return Oscillator$WebAudio.setFrequency(frequency, lfo.oscillatorNode);
}

function getFrequency(lfo) {
  return Oscillator$WebAudio.getFrequency(lfo.oscillatorNode);
}

var defaultFrequency = 3.0;

export {
  defaultFrequency ,
  make ,
  connect ,
  start ,
  setFrequency ,
  getFrequency ,
  
}
/* Oscillator-WebAudio Not a pure module */
